/*
 * @Author: Teemo Ding
 * @Date: 2022-02-11 09:58:42
 * @LastEditTime: 2022-06-29 15:05:05
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/CommunicationDetail/tool.ts
 */
import { maskEmail, maskPhone, maskFullName } from '@/src/tools/mask';
import { CommunicationChannelType } from 'src/types/common/communication';

export const breadcrumbData = (orderNo, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/communicationList',
    name: getI18n('communication.communicationList.communication'),
  },
  {
    url: '',
    name: `#${orderNo}`,
  },
];

export function getContactName({
  customerUuid,
  fullName,
  lastName,
  firstName,
  isVisible,
  contactName,
  channelType,
}) {
  if (customerUuid) {
    return isVisible ? fullName : maskFullName(lastName, firstName, fullName);
  }
  return isVisible
    ? contactName
    : channelType === CommunicationChannelType.Email
    ? maskEmail(contactName)
    : maskPhone(contactName, true);
}
